export default "__VITE_ASSET__f8486813__"